import React from 'react';

const NotificationsPane = ({ localPreferences, onChange }) => (
  <section className="settings-modal__section">
    <h3 className="settings-modal__section-title">Desktop</h3>

    <div className="settings-modal__setting">
      <div className="settings-modal__setting-row">
        <div className="settings-modal__setting-text">
          <label className="settings-modal__label">Windows notifications</label>
          <p className="settings-modal__description">
            When Fokus is in the background, show a Windows toast for new
            reminders and “it's time” pings. Click the toast to jump to the mission.
          </p>
        </div>
        <button
          type="button"
          className={`settings-modal__toggle ${
            localPreferences.desktopNotifications !== false
              ? 'settings-modal__toggle--active'
              : ''
          }`}
          onClick={() =>
            onChange('desktopNotifications', localPreferences.desktopNotifications === false)
          }
          role="switch"
          aria-checked={localPreferences.desktopNotifications !== false}
        >
          <span className="settings-modal__toggle-knob" />
        </button>
      </div>
    </div>
  </section>
);

export default NotificationsPane;
